import React, { useState } from "react";
import api from "../../services/api";

// Formulaire « Nous contacter » : la demande arrive dans la file de la
// Community Manager (rubrique Communauté). Un visiteur laisse un contact ;
// un utilisateur connecté reçoit la réponse dans sa messagerie.
export default function ContactForm({ connecte = false, sombre = false }) {
  const [ouvert, setOuvert] = useState(false);
  const [champs, setChamps] = useState({ nom: "", contact: "", sujet: "", message: "", site_web: "" });
  const [etat, setEtat] = useState({ envoi: false, erreur: "", ok: "" });
  const maj = cle => e => setChamps(c => ({ ...c, [cle]: e.target.value }));

  const envoyer = async e => {
    e.preventDefault();
    setEtat({ envoi: true, erreur: "", ok: "" });
    try {
      const r = await api.post("contact/", champs);
      setEtat({ envoi: false, erreur: "", ok: `${r.data.detail}${r.data.reference ? ` (réf. ${r.data.reference})` : ""}` });
      setChamps({ nom: "", contact: "", sujet: "", message: "", site_web: "" });
    } catch (err) {
      setEtat({ envoi: false, ok: "", erreur: err.response?.data?.detail || "Envoi impossible. Vérifiez votre connexion." });
    }
  };

  if (!ouvert) {
    return (
      <button type="button" className={`btn ${sombre ? "btn-warning" : "btn-outline-primary"}`} onClick={() => setOuvert(true)}>
        <i className="bi bi-chat-left-text me-2"></i>Écrire à l'équipe
      </button>
    );
  }
  const couleurTexte = sombre ? "#e2e8f0" : undefined;
  return (
    <form onSubmit={envoyer} style={{ maxWidth: 560, margin: "0 auto", textAlign: "left" }} aria-label="Nous contacter">
      {!connecte && (
        <div className="row g-2 mb-2">
          <div className="col-sm-6">
            <label className="form-label small" style={{ color: couleurTexte }}>Votre nom</label>
            <input className="form-control" value={champs.nom} onChange={maj("nom")} required maxLength={200} />
          </div>
          <div className="col-sm-6">
            <label className="form-label small" style={{ color: couleurTexte }}>E-mail ou téléphone</label>
            <input className="form-control" value={champs.contact} onChange={maj("contact")} required maxLength={200} />
          </div>
        </div>
      )}
      <label className="form-label small" style={{ color: couleurTexte }}>Sujet</label>
      <input className="form-control mb-2" value={champs.sujet} onChange={maj("sujet")} required maxLength={200} />
      <label className="form-label small" style={{ color: couleurTexte }}>Message</label>
      <textarea className="form-control mb-2" rows={4} value={champs.message} onChange={maj("message")} required maxLength={3000} />
      {/* Champ invisible : seuls les robots le remplissent. */}
      <input type="text" name="site_web" value={champs.site_web} onChange={maj("site_web")} tabIndex={-1}
        autoComplete="off" aria-hidden="true" style={{ position: "absolute", left: "-9999px" }} />
      <p className="small mb-2" style={{ color: sombre ? "#94a3b8" : "#6b7280" }}>
        Ne communiquez ni mot de passe ni code de manuel dans ce message.
      </p>
      <div className="d-flex gap-2 flex-wrap">
        <button type="submit" className={`btn ${sombre ? "btn-warning" : "btn-primary"}`} disabled={etat.envoi}>
          {etat.envoi ? "Envoi…" : "Envoyer"}
        </button>
        <button type="button" className="btn btn-link" style={{ color: couleurTexte }} onClick={() => setOuvert(false)}>Fermer</button>
      </div>
      {etat.ok && <div className="alert alert-success mt-2 mb-0 py-2" role="status">{etat.ok}</div>}
      {etat.erreur && <div className="alert alert-danger mt-2 mb-0 py-2" role="alert">{etat.erreur}</div>}
    </form>
  );
}
